import { List } from '@sayyesschool/frontend/ui-components';

import LessonsListItem from './LessonsListItem';

export default function LessonsList({ lessons, onReorder, onDelete }) {
    return (
        <List className="LessonList NumberedList">
            {lessons.map((lesson, index) =>
                <LessonsListItem
                    key={lesson.id}
                    index={index}
                    lesson={lesson}
                    first={index === 0}
                    last={index === lessons.length - 1}
                    onMove={onReorder}
                    onDelete={onDelete}
                />
            )}
        </List>
    );
}